import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Use the real authentication state
  const { currentUser, signOut } = useAuth();
  const isAuthenticated = !!currentUser;
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Close menu when location changes (user navigates to a new page)
  useEffect(() => {
    setIsMenuOpen(false);
    
    // Force scroll to top on navigation
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [location]);
  
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  const handleLogout = () => {
    signOut();
    navigate('/');
  };
  
  // Custom link handler to ensure scroll to top
  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };
  
  return (
    <nav className={`navbar navbar-expand-lg navbar-light fixed-top ${scrolled ? 'navbar-scrolled' : ''}`} 
         style={{
           backgroundColor: '#fff',
           boxShadow: '0 2px 15px rgba(0, 0, 0, 0.04)',
           padding: scrolled ? '0.5rem 0' : '1rem 0',
           transition: 'all 0.3s ease'
         }}>
      <div className="container">
        <Link className="navbar-brand" to="/" style={{
          fontFamily: "'Quicksand', sans-serif",
          fontWeight: 700,
          fontSize: '1.8rem',
          color: 'var(--primary)'
        }} onClick={handleLinkClick}>
          <i className="bi bi-moon-stars me-2" style={{ fontSize: '1.5rem' }}></i>
          Dozzy.au
        </Link>
        
        <button 
          className="navbar-toggler" 
          type="button" 
          onClick={toggleMenu}
          aria-controls="navbarNav" 
          aria-expanded={isMenuOpen ? "true" : "false"} 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`} 
                to="/"
                onClick={handleLinkClick}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`} 
                to="/about"
                onClick={handleLinkClick}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/pricing' ? 'active' : ''}`} 
                to="/pricing"
                onClick={handleLinkClick}
              >
                Pricing
              </Link>
            </li>
            
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/faq' ? 'active' : ''}`} 
                to="/faq"
                onClick={handleLinkClick}
              >
                FAQ
              </Link>
            </li>
            
            
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/gift' ? 'active' : ''}`} 
                to="/gift"
                onClick={handleLinkClick}
              >
                Gift a Sleep Plan
              </Link>
            </li>
            
            <li className="nav-item">
              <Link 
                className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`} 
                to="/contact"
                onClick={handleLinkClick}
              >
                Contact
              </Link>
            </li>
          </ul>
          
          <div className="ms-lg-3 mt-3 mt-lg-0 d-flex">
            {isAuthenticated ? (
              <>
                <Link 
                  className={`btn btn-red me-2 ${location.pathname.startsWith('/dashboard') ? 'active' : ''}`} 
                  to="/dashboard"
                  onClick={handleLinkClick}
                >
                  Dashboard
                </Link>
                <button 
                  className="btn btn-outline-red me-2" 
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-outline-red me-2" onClick={handleLinkClick}>Login</Link>
                <Link to="/signup" className="btn btn-red" onClick={handleLinkClick}>Get Your Sleep Plan</Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
